
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { useState } from 'react';
import { Playground, PropsTable } from "docz";
import Icon from '../shared/components/Icon.js'
import Button from "../shared/components/Button.js";
import "../shared/css/index.css";

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"button"}}>{`Button`}</MDXTag>
<Playground __position={0} __code={'() => {\n  const [action, setAction] = useState(\'cta\')\n  const [hierarchy, setHierarchy] = useState(\'primary\')\n  const [size, setSize] = useState(\'md\')\n  const [disabled, setDisabled] = useState(false)\n  const [full, setFull] = useState(false)\n  const actions = [\n    \'cta\',\n    \'success\',\n    \'destructive\',\n    \'warning\',\n    \'dark\',\n    \'light\',\n    \'link\',\n  ]\n  const hierarchies = [\'primary\', \'secondary\', \'tertiary\']\n  const sizes = [\'lg\', \'md\', \'sm\']\n\n  return (\n    <div>\n      <div>\n        <label>Action</label>\n        <select\n          value={action}\n          onChange={e => {\n            setAction(e.target.value)\n          }}\n        >\n          {actions.map(actionVal => (\n            <option value={actionVal}>{actionVal}</option>\n          ))}\n        </select>\n      </div>\n      <div>\n        <label>Hierarchy</label>\n        <select\n          value={hierarchy}\n          onChange={e => {\n            setHierarchy(e.target.value)\n          }}\n        >\n          {hierarchies.map(hierarchyVal => (\n            <option value={hierarchyVal}>{hierarchyVal}</option>\n          ))}\n        </select>\n      </div>\n      <div>\n        <label>Size</label>\n        <select\n          value={size}\n          onChange={e => {\n            setSize(e.target.value)\n          }}\n        >\n          {sizes.map(sizeVal => (\n            <option value={sizeVal}>{sizeVal}</option>\n          ))}\n        </select>\n      </div>\n      <div>\n        <label>Disabled</label>\n        <input\n          type=\"checkbox\"\n          value={disabled}\n          onChange={e => setDisabled(d => !d)}\n        />\n      </div>\n      <div>\n        <label>Full</label>\n        <input\n          type=\"checkbox\"\n          value={full}\n          onChange={e => setFull(f => !f)}\n        />\n      </div>\n      <Button\n        action={action}\n        hierarchy={hierarchy}\n        size={size}\n        disabled={disabled}\n        full={full}\n      >\n        Button\n      </Button>\n    </div>\n  )\n}'} __scope={{props: this ? this.props : props,useState,Icon,Button}}>
  { () => {
    const [action, setAction] = useState('cta');
    const [hierarchy, setHierarchy] = useState('primary');
    const [size, setSize] = useState('md');
    const [disabled, setDisabled] = useState(false);
    const [full, setFull] = useState(false);
const actions = ["cta", "success", "destructive", "warning", "dark", "light", "link"]
const hierarchies = ['primary', 'secondary', 'tertiary']
const sizes = ['lg', 'md', 'sm']

return (
  <div>
    <div>
      <label>Action</label>
      <select value={action} onChange={
        (e) => {
          setAction(e.target.value)
        }
      }>
        {actions.map(actionVal => <option value={actionVal}>{actionVal}</option>)}
      </select>
    </div>
    <div>
      <label>Hierarchy</label>
      <select value={hierarchy} onChange={
        (e) => {
          setHierarchy(e.target.value)
        }
      }>
        {hierarchies.map(hierarchyVal => <option value={hierarchyVal}>{hierarchyVal}</option>)}
      </select>
    </div>
    <div>
      <label>Size</label>
      <select value={size} onChange={
        (e) => {
          setSize(e.target.value)
        }
      }>
        {sizes.map(sizeVal => <option value={sizeVal}>{sizeVal}</option>)}
      </select>
    </div>
    <div>
      <label>Disabled</label>
      <input type="checkbox" value={disabled} onChange={(e) => setDisabled(d => !d)}/>
    </div>
    <div>
      <label>Full</label>
      <input type="checkbox" value={full} onChange={(e) => setFull(f => !f)}/>
    </div>
    <Button action={action} hierarchy={hierarchy} size={size} disabled={disabled} full={full}>Button</Button>
  </div>
)
  }}
</Playground>
<PropsTable of={Button} />
<MDXTag name="h2" components={components} props={{"id":"custom-onclick-handler"}}>{`Custom onClick handler`}</MDXTag>
<Playground __position={2} __code={'<Button onClick={() => alert(\'Hola!\')}>Button</Button>'} __scope={{props: this ? this.props : props,useState,Icon,Button}}>
  <Button onClick={() => alert('Hola!')}>Button</Button>
</Playground>
<MDXTag name="h2" components={components} props={{"id":"button-with-icons"}}>{`Button with icons`}</MDXTag>
<MDXTag name="p" components={components}>{`Aquí es necesario encerrar el texto con la etiqueta `}<MDXTag name="em" components={components} parentName="p">{`span`}</MDXTag>{` (o el componente Text) para que se apliquen los márgenes correspondientes entre cada elemento hijo. `}</MDXTag>
<Playground __position={3} __code={'<Button>\n  <Icon shape=\"conversation\" />\n  <span>Mensajes</span>\n</Button>\n<Button>\n  <span>Mensajes</span>\n  <Icon shape=\"conversation\" />\n</Button>'} __scope={{props: this ? this.props : props,useState,Icon,Button}}>
  <Button>
    <Icon shape="conversation" />
    <span>Mensajes</span>
  </Button>
  <Button>
    <span>Mensajes</span>
    <Icon shape="conversation" />
  </Button>
</Playground>
           </MDXTag>
  }
}
  